<template>
  <Layout>
    <PageHeader
      :title="title"
      moda_title="Datos del operador"
      ref="pageForm"
      :items="items"
      v-if="isItForAdmin"
    >
    </PageHeader>
    <CrupierScreen v-if="userIsCrupier" :role="role" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="isItForAdmin">
            <p class="m-0">BIENVENIDO!</p>
            <!-- <main-data :items="tableData"></main-data> -->
          </div>
          <ClientDashboard v-if="role === 'CLIENT'" />
        </div>
        <CounterUsersConnected v-if="isItForAdmin" :roulettes="getGamesActive"  />

      </div>
    </div>
  </Layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Layout from '@/views/layouts/main';
import PageHeader from '@/components/page-header-simple';
import appConfig from '@/app.config';
// import MainData from '../../../components/main-data.vue';
import CrupierScreen from '../Crupiers/CrupierScreen.vue';
// import Multiselect from 'vue-multiselect';
import { breadCrumbData } from '../../../helpers/breadcrumbs/breadCrumbs';
import ClientDashboard from '../clients/components/ClientDashboard.vue';
import CounterUsersConnected from './components/CounterUsersConnected.vue';

/**
 * Users-table component
 */
export default {
  page: {
    title: 'Dasboard Table',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // MainData,
    // Multiselect,
    CrupierScreen,
    ClientDashboard,
    CounterUsersConnected
  },
  data() {
    return {
      role: '',
      userData: null,
      user: null,
      tableData: [],
      title: this.$t('sidebar.home'),
      items: breadCrumbData.home,
      loading: false,
      filterData: {},
      dataDetails: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      clients: [],
      operators: [],
      roulettes: [],
      sortBy: 'age',
      sortDesc: false,
      fields: [
        {
          key: 'username',
          sortable: true,
          label: this.$t('betDetail.user'),
        },
        {
          key: 'userId',
          sortable: true,
          label: this.$t('tableReports.userId'),
        },
        {
          key: 'operator',
          sortable: true,
          label: this.$t('tableReports.operator'),
        },
        {
          key: 'roundCount',
          sortable: true,
          label: 'Round Count',
        },
        {
          key: 'totalBet',
          sortable: true,
          label: this.$t('betDetail.totalBet'),
        },
        {
          key: 'totalWin',
          sortable: true,
          label: 'Total Win',
        },
        {
          key: 'profit',
          sortable: true,
          label: this.$t('tableReports.profit'),
        },
      ],

      clientFilter: null,
      operator: '',
      roulette: '',
      chatvalue: '',
      token: '',
      channel: {},
      client: {},
      messages: null,

      viewSelected: null,
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length;
    },
    userDataAct() {
      return this.$store.dispatch('user/setUserAct');
    },
    ...mapGetters({
      mapOperators: 'operators/getOperators',
      mapGames: 'games/getGames',
      getViewSelected: 'crupiers/getViewSelected',
      isItForAdmin: 'user/onlyAdminRole',
      userIsCrupier: 'user/isCrupier',
      getGamesActive:'games/getGamesActive'
    }),
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getUserData();
  },
  methods: {
    addValue(prop, value) {
      if (value) {
        return (this.filterData[prop] = value._id);
      }

      const { [prop]: type, ...rest } = this.filterData;

      this.filterData = rest;
      return type;
    },
    handleSelection(value, type) {
      switch (type) {
        case 'Operator':
          this.addValue('operadorId', value);
          break;
        case 'Roulette':
          this.addValue('rouletteId', value);
          break;
        default:
          break;
      }

      this.getData();
    },
    cancelFilter() {
      this.operator = '';
      this.roulette = '';
      this.filterData = {};
      this.getData();
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getUserData() {
      const userData = this.$store.getters['user/getUserData'];
      this.role = this.$store.getters['user/getRole'];
      this.userData = userData;
    },
    async handleMenu() {
      await this.handleMenuOptions();
      this.viewSelected = this.getViewSelected;
    },
    ...mapActions({
      fetchGames: 'games/fetchGames',
      handleMenuOptions: 'crupiers/handleMenuOptions',
    }),
  },
  middleware: 'authentication',
};
</script>

<style>
.space-nowrap {
  white-space: nowrap !important;
}
</style>
